<script setup lang="ts">
import { useGetMe } from "@/auth/useMe";
import { usePermissions } from "@/auth/usePermissions";
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import StatsList from "@/components/StatsList.vue";
import ManagementLayout from "@/layouts/ManagementLayout.vue";
import { useGetStats } from "@/stats/useStats";
import { Download } from "@iconoir/vue";
import { pick } from "lodash-es";
import { computed } from "vue";
import { useGetContacts } from "./contactsCrud";
import ContactsTable from "./ContactsTable.vue";
import { useFilter } from "./useFilter";

const { contacts, getContactsStatus } = useGetContacts();
const { me } = useGetMe();
const { canAccess } = usePermissions(me);

const { stats, getStatsStatus } = useGetStats();
const contactStats = computed(() => {
  if (!stats.value) return undefined;
  return pick(stats.value, ["totalContacts", "totalPotentialCoreActivists"]);
});

const { query, filteredContacts } = useFilter(contacts);
</script>

<template>
  <ManagementLayout>
    <template #header>
      <div class="multi-columns">
        <div class="column">
          <h1>Kontakte</h1>
          <HandleQueryStatus :query-status="getStatsStatus">
            <StatsList
              v-if="contactStats !== undefined"
              :stats="contactStats"
            />
          </HandleQueryStatus>
          <a
            v-if="canAccess('export')"
            href="/export/contacts.csv"
            download
            role="button"
            class="button"
          >
            <Download /> alle Kontakte runterladen (.csv)
          </a>
        </div>
        <div class="filter-form">
          <form class="column" @submit.prevent>
            <label for="search" class="visually-hidden"
              >Suche nach Name, Adresse, Telefonnummer oder Nutzer:in</label
            >
            <input
              id="search"
              v-model="query.search"
              type="text"
              placeholder="Suche nach Name, Adresse, Telefonnummer oder Nutzer:in"
            />

            <div>
              <label for="status" class="visually-hidden">Status</label>
              <select id="status" v-model="query.status" name="status">
                <option :value="null">Nach Status filtern...</option>
                <option value="isHouseSpeaker">Haussprecher:in</option>
                <option value="isPotentialCoreActivist">
                  potentielle:r Kernaktive:r
                </option>
                <option value="hasNoInterestInBecomingActive">
                  kein Interesse
                </option>
              </select>
            </div>
          </form>
        </div>
      </div>
    </template>

    <HandleQueryStatus :query-status="getContactsStatus">
      <ContactsTable :contacts="filteredContacts" />
    </HandleQueryStatus>
  </ManagementLayout>
</template>

<style scoped>
.filter-form {
  align-self: end;
}
</style>
